var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightMoustache(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.744,
    height: 34.114,
    viewBox: "0 0 84.744 34.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1646",
    "data-name": "Rectangle 1646",
    width: 84.744,
    height: 34.114,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5116",
    "data-name": "Group 5116",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5112",
    "data-name": "Group 5112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12026",
    "data-name": "Path 12026",
    d: "M20.417,14.517A8.418,8.418,0,0,1,17.694,22.6a10.539,10.539,0,0,1-8.437,2C3.08,23.678-.659,17.07.1,11.2.739,5.072,6.485.513,12.4.114,18.361-.5,24.2,1.464,29.4,4.056c10.372,5.17,19.4,13.761,31.171,14.8,2.812.106,5.885.106,8.429-1.04a9.185,9.185,0,0,0,5.1-6.4c.423-2.715-1.138-6.031-4.113-6.2a3.758,3.758,0,0,0-3.568,1.626,4.339,4.339,0,0,0-.024,4L66.024,11a4.877,4.877,0,0,1-.268-4.576,4.738,4.738,0,0,1,4.316-2.349,5.667,5.667,0,0,1,4.56,2.512,8.923,8.923,0,0,1,1.374,5.1c-.211,3.788-2.829,6.689-5.82,8.486a11.542,11.542,0,0,1-2.617,1.065l-2.382.423A23.47,23.47,0,0,1,60.343,22c-6.649.008-12.509-3.032-17.744-5.828-5.259-2.918-10.071-6.153-15.013-8.5C22.758,5.219,17.71,3.406,12.769,3.821a10.147,10.147,0,0,0-9.542,7.771c-.9,4.43,1.569,9.876,6.413,10.94a8.831,8.831,0,0,0,7.258-.894,7.524,7.524,0,0,0,3.121-7.047Z",
    transform: "translate(0.001 -0.002)",
    fill: "#feb616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12027",
    "data-name": "Path 12027",
    d: "M3.147,1.694c12.1,2.634,21.8,10.908,33.22,14.8,5.617,2.048,11.973,2.585,17.581.406A13.59,13.59,0,0,0,60.3,10.879a7.24,7.24,0,0,0-.748-8.266l.309-.26C62.678,4.1,63.621,8.5,62.312,11.879a16.259,16.259,0,0,1-7.023,8.055c-6.608,3.016-14.021,2.487-20.231.374a85.875,85.875,0,0,1-16.525-8.949A125.563,125.563,0,0,0,3.066,2.092Z",
    transform: "translate(21.855 12.074)",
    fill: "#feb616"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMoustache);
export default __webpack_public_path__ + "static/media/rightMoustache.e948ba1ea3bcd654ed1aa17d13ff51aa.svg";
export { ForwardRef as ReactComponent };